// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-1861b2f2],th[data-v-1861b2f2]{text-align:center!important}", ""]);
// Exports
module.exports = exports;
